import { createContext, useContext, type ReactNode } from 'react'
import { CHART_COLORS } from './chartStyle'

const ChartPaletteCtx = createContext<string[]>(CHART_COLORS)

/** Fournit la palette de séries résolue aux widgets charts descendants. */
export function ChartPaletteProvider({ palette, children }: { palette: string[]; children: ReactNode }) {
  return <ChartPaletteCtx.Provider value={palette && palette.length ? palette : CHART_COLORS}>{children}</ChartPaletteCtx.Provider>
}

/** Palette de séries courante (défaut CHART_COLORS hors provider). */
export function useChartPalette(): string[] {
  return useContext(ChartPaletteCtx)
}
